import React, { useEffect, useState } from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Express_URL from "../Components/Express_URL";
import { Img_URL1 } from "./Ads_URL";

const SimilarYacht = () => {
  const [yachts, setYachts] = useState([]);
  const make = "HCB";
  const condition = "New";
  const fetchData = (start, rows) => {
    let apiUrl = `https://americanyachtgroupinternational.com/api/documents?brand=HCB&priority_brokerage=40000836`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        // Ensure the response is assigned to 'data'
        console.log("API Response:", data);

        // Correct the reference here:
        const yachtsArray = data?.yacht_data?.["V-Data"] || []; // Ensure correct data access

        // Limit to the first 8 yachts
        const limitedYachts = yachtsArray.slice(0, 3);
        setYachts(limitedYachts); // Update state with limited yachts
      })
      .catch((error) => console.error("Error fetching yachts:", error));
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <Row className="g-3">
        {yachts.length === 0 ? (
          <div className="text-center">
            <Spinner animation="border" variant="warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          yachts.map((yacht, index) => (
            <React.Fragment key={yacht.ID}>
              <Col xs={12} md={6} lg={4}>
                <Link to={`/yachtdetails/${yacht.ID}`} className="">
                  <div
                    className="card border-0"
                    style={{
                      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                    }}
                  >
                    <img
                      src={
                        yacht.DisplayPicture?.Large ||
                        yacht.DisplayPicture?.Medium
                      }
                      className="card-img-top"
                      alt="..."
                      loading="lazy"
                      height={"260px"}
                    />
                    <div className="card-body p-2">
                      <div className="text-start">
                        <h5 className="fw-bold mb-1">
                          {yacht.Manufacturer}{" "}
                          <span className="text-dark">{yacht.Model}</span>
                        </h5>
                      </div>
                      <p className="text-dark mb-0 ">
                        {yacht.Year} | {yacht.City}, {yacht.State},{" "}
                        {yacht.Country}
                      </p>
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold">
                            {yacht.PriceHidden
                              ? "$ Call For Price"
                              : yacht.PriceUSD != null
                              ? new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(yacht.PriceUSD)
                              : "$ Not Available"}
                          </p>
                        </div>
                        <div className="text-dark fw-bold">
                          View Details{" "}
                          <i className="fa-solid fa-angles-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>

              {/* Display advertisement after the 3rd card
              {index === 2 && (
                <Col xs={12} md={6} lg={4} key="advertisement">
                  <div
                    className="border-0 py-4 rounded-2 bg-white"
                    style={{
                      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={Img_URL1}
                        alt="Advertisement"
                        height={"305px"}
                        width={"auto"}
                      />
                    </div>
                  </div>
                </Col>
              )} */}
            </React.Fragment>
          ))
        )}
      </Row>
      {yachts.length === 0 && <Alert variant="warning">No yachts found.</Alert>}
    </div>
  );
};

export default SimilarYacht;
